<template>
	<aside class="col-12 col-md-5 col-lg-3 col-xl-3 aside">
		<div class="sidebar-box border-0 pb-0">
			<strong class="h2 text-uppercase">Download app</strong>
			<div class="sidebar-box-inner">
				<ul class="download-apps-btn">
					<li>
                                            <a target="_blank" href="https://apps.apple.com/gb/app/planetcricket/id1562153858">
                                                <img width="135" height="40" class="lazyload" :src="require('@/assets/images/app-store.png')" alt="app store" /></a>
					</li>
					<li>
						<a target="_blank" href="https://play.google.com/store/apps/details?id=com.sportcc.planetcricket">
                                                    <img width="135" height="40" class="lazyload" :src="require('@/assets/images/google-play.png')" alt="google play" /></a>
					</li>
				</ul>
			</div>
		</div>
		<match-standings></match-standings>
		<upcoming-matches></upcoming-matches>
		<match-highlights></match-highlights>
	</aside>
</template>

<script>
import MatchStandings from './_Standings'
import UpcomingMatches from './_Upcoming'
import MatchHighlights from './_Highlights'

export default {
	name: 'matchDetailRightSidebar',

	components: { MatchStandings, UpcomingMatches, MatchHighlights },

	data() {
		return {}
	},

	mounted() {},

	methods: {}
}
</script>
